import Home from '../components/home/Home';
import Authentication from '../components/authentication/Authentication';
import Oms from '../components/oms/Oms';
import TaskDetail from '../components/oms/TaskDetail/TaskDetail';
import PurchaseOrderDetail from '../components/oms/PurchaseOrderDetail/PurchaseOrderDetail';
import XetTrack from '../components/xetTrack/XetTrack';
import XetDeliveryCalendar from '../components/XetDeliveryCalendar/XetDeliveryCalendar';
import XetNotification from '../components/shared/xet-notification/XetNotification';
import Sku from '../components/Sku/Sku';
import SkuDetail from '../pages/SkuDetail/SkuDetail';
import DeliveryDetail from '../pages/DeliveryDetail/DeliveryDetail';
import Invoices from '../pages/Invoices/Invoices';
import Clients from '../pages/Clients/Clients';
import ClientDetail from '../pages/ClientDetail/ClientDetail';
import BoxChat from '../pages/BoxChat/BoxChat';
import ClientBillingAdmin from '../pages/ClientBillingAdmin';
import { Planning } from '../pages/Planning';
import DieLine from '../pages/DieLine/DieLine';

const routes = [
  {
    path: '/files',
    Component: Home,
    protected: true,
  },
  {
    path: '/',
    Component: Authentication,
    protected: false,
  },
  {
    path: '/eqs/:category',
    Component: Oms,
    protected: true,
  },
  {
    path: '/eqs/:category/:id',
    Component: TaskDetail,
    protected: true,
  },
  {
    path: '/eqs/:category/:id/vendor/:vendor_id',
    Component: TaskDetail,
    protected: true,
  },
  {
    path: '/xetrack/:category',
    Component: XetTrack,
    protected: true,
  },
  {
    path: '/xetrack/:category/:id',
    Component: PurchaseOrderDetail,
    protected: true,
  },
  {
    path: '/xetrack/:category/:id/vendor/:vendor_id',
    Component: PurchaseOrderDetail,
    protected: true,
  },
  {
    path: '/delivery-calendar',
    Component: XetDeliveryCalendar,
    protected: true,
  },
  {
    path: '/sku',
    Component: Sku,
    protected: true,
  },
  {
    path: '/notifications',
    Component: XetNotification,
    protected: true,
  },
  {
    path: '/skus/:id',
    Component: SkuDetail,
    protected: true,
  },
  {
    path: '/delivery-detail/:id',
    Component: DeliveryDetail,
    protected: true,
  },
  {
    path: '/invoices',
    Component: Invoices,
    protected: true,
  },
  {
    path: '/clients',
    Component: ClientBillingAdmin,
    protected: true,
  },
  {
    path: '/clients/:id',
    Component: ClientDetail,
    protected: true,
  },
  {
    path: '/chat',
    Component: BoxChat,
    protected: true,
  },
  {
    path: '/planning',
    Component: Planning,
    protected: true,
  },
  {
    path: '/dieline',
    Component: DieLine,
    protected: true,
  },
];

export default routes;
